import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Portfolio"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 7.5H16.5V4.5C16.5 3.67157 15.8284 3 15 3H9C8.17157 3 7.5 3.67157 7.5 4.5V7.5H3C2.17157 7.5 1.5 8.17157 1.5 9V19.5C1.5 20.3284 2.17157 21 3 21H21C21.8284 21 22.5 20.3284 22.5 19.5V9C22.5 8.17157 21.8284 7.5 21 7.5ZM9 4.5H15V7.5H9V4.5ZM3 19.5V9H21V19.5H3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Portfolio.vue"]]);
